import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mode-list",
  "use": "mode-list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"mode-list\"><path d=\"M15 13.1c.4 0 .8.3.8.8 0 .4-.3.7-.6.7H1c-.4 0-.8-.3-.8-.8 0-.4.3-.7.6-.7H15zm0-5.9c.4 0 .8.3.8.8 0 .4-.3.7-.6.7H1c-.4 0-.8-.3-.8-.8 0-.4.3-.7.6-.7H15zm0-5.8c.4 0 .8.3.8.8 0 .4-.3.7-.6.7H1c-.4 0-.8-.3-.8-.8 0-.4.3-.7.6-.7H15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/mode-list.svg
// module id = AS0L
// module chunks = 6